
import React from "react";
import { Controller } from "react-hook-form";
import { Grid, Divider } from "@mui/material";
import MDTypography from "dashboard/components/MDTypography";
import MDEditor from "dashboard/components/MDEditor";
import UserMap from "dashboard/layouts/distributers/sections/form/components/UserMap";

const dividersTitle = ["Contact de l'entreprise", "Coordonnées de l'entreprise"];
const dividers = ["mobile","location.street"];

const ThirdStep = (props) => {
    const { control, errors, setValue, step,distributer, renderFormFields } = props;
    const handleEditorChange = (value) =>{
			setValue('description', value);
		}
  return (
    <Grid container  spacing={{ xs: 1, md: 2 }} p={2} >
         {step.map((item, index) =>(
            // eslint-disable-next-line
            <React.Fragment key={`item-${index}`} > 
                {dividers.includes(item.name) && (
                <Grid xs={12} item>
                {index !==0 && <Divider/>}
                <MDTypography variant="h6" color="text" >{dividersTitle[dividers.indexOf(item.name)]}</MDTypography>
                </Grid>)}
                <Grid   xs={6} item >
                {renderFormFields(item,index, Controller, 2)}
                </Grid>
            </React.Fragment>
          ))}
          <Grid xs={12} item>
          <MDTypography variant="h6" mb={1} color="text" >Choisir votre position</MDTypography>
          <UserMap setValue={setValue} initPosition={distributer.location.coordinates} />
          </Grid>
          <Grid xs={12} item>
            <Divider/>
            <MDTypography variant="h6" color="text" >à propos</MDTypography>
          </Grid>
        <Grid xs={12}   item>
            <Controller name="description" control={control} onChange={([, data]) => data}
                rules={{ required: false }}
                /* eslint-disable */
                render={({ field: { onChange, value } }) => (
                <MDEditor  value={value}
                placeholder="A propos du fournisseur ?" 
                onChange={handleEditorChange}
								required={false}
                error={Boolean(errors.description)}
                helperText={errors.description?.message} 
                fullWidth/>
                )}
            />
        </Grid>
    </Grid>
  )
}

export default ThirdStep